import CheckedIcon from '@/components/icons/CheckedIcon';
import UncheckedIcon from '@/components/icons/UncheckedIcon';
import { FC } from 'react';

type Props = {
    text: string;
    onClick?: () => void;
    checked?: boolean;
};

const NotificationCreateStep1Element: FC<Props> = ({ text, onClick, checked = false }) => {
    return (
        <div
            className="py-3 px-3.5 flex items-center gap-2.5 border border-popover-100 rounded-semi-xl hover:bg-primary-color-100 cursor-pointer"
            onClick={onClick}
        >
            <div className="size-5">
                {checked ? (
                    <CheckedIcon className="fill-primary-color stroke-primary-color" />
                ) : (
                    <UncheckedIcon />
                )}
            </div>
            <span className="text-xs">{text}</span>
        </div>
    );
};

export default NotificationCreateStep1Element;
